import { throttle } from "lodash";
import { useState, useCallback, RefObject, useRef, useEffect } from "react";

const useComponentPosition = (): {
  top: number | null;
  left: number | null;
  ref: RefObject<HTMLDivElement>;
} => {
  const ref = useRef<HTMLDivElement>(null);

  const [mounted, setMounted] = useState(false);
  const [position, setPosition] = useState<{
    top: number | null;
    left: number | null;
  }>({
    top: null,
    left: null
  });

  const measure = useCallback(
    throttle((el: HTMLDivElement) => {
      if (el) {
        const { top, left } = el.getBoundingClientRect();
        if (top || left) setPosition({ top, left });
      }
    }, 0),
    []
  );

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const measureCurrentNode = () => {
      if (ref.current) measure(ref.current);
    };

    measureCurrentNode();

    if (mounted) window.addEventListener("scroll", measureCurrentNode);

    return () => {
      if (mounted) window.removeEventListener("scroll", measureCurrentNode);
    };
  }, [ref.current, mounted]);

  return { ...position, ref };
};

export default useComponentPosition;
